import { Toaster } from 'react-hot-toast';
import { RouterProvider } from 'react-router';

import { TawkToWidget } from './components/TawkTo/TawkToWidget';
import { ToastWrapper } from './components/ToastWrapper/ToastWrapper';
import { interceptors } from './interceptors';
import { router } from './routes/routes';

interceptors.errorInterceptor();

function App() {
  return (
    <>
      <TawkToWidget />
      <ToastWrapper>
        <Toaster position='top-center' reverseOrder={false} />
      </ToastWrapper>
      <RouterProvider router={router} />
    </>
  );
}

export default App;
